<template>
  <div id="home-view" class=" custom-scrollbar-grey">
    <HeaderContent :title="`${$t('home.greet')} ${$store.state.user.name}`">
      <div slot="main">
        <p class="text-muted">
          {{$t("home.message")}}
        </p>
      </div>
      <div slot="menu">
        <!-- <button>My Templates</button> -->

        <button class="btn btn-md btn-primary btn-flex add-template" @click="onAddTemplate">
          <i class="fa-light fa-plus"></i>
          {{ $t("home.add-template-btn") }}
        </button>
      </div>
    </HeaderContent>

    <div id="home" class="d-flex flex-grow-1 align-items-stretch ">
      <div class="template-picker flex-grow-1  auto-max-width">
        <!-- <h1>{{$t('home.title')}}</h1> -->
        <div class="top">
          <filter-searchbar
            :filterOptions="filters"
            @on-filter-change="selectedFilterChanged"
            :selectedFilter="selectedFilter"
            :placeholder="$t('home.search-template-placeholder')"
            v-model="searchFilter"
          />
        </div>
        <template-list
          :templates="filteredTemplates"
          :publications="$store.state.templates.filter((t) => t.published)"
          @template-selected="onTemplateSelected"
          @success="showNotice"
          @add-template="onAddTemplate"
        />
      </div>
    </div>

    <template-side-panel
      v-if="selectedTemplate"
      :template="selectedTemplate"
      :publications="
        $store.state.templates.filter((t) => t.published && t.publishedFromId === selectedTemplate.id) || []
      "
      @close="selectedTemplate = null"
      @success="showNotice"
    />
  </div>
</template>

<script>
import TemplateList from "@/components/TemplateList";
import TemplateSidePanel from "@/components/TemplateSidePanel";
import CreateTemplateModal from "@/components/modals/CreateTemplateModal";
import demoHelper from "@/assets/js/demoHelper.js";
import FilterSearchbar from "@/components/FilterSearchbar.vue";
import HeaderContent from "@/components/HeaderContent.vue";
export default {
  name: "home",
  props: {
    postDemoGuide: Boolean
  },
  data() {
    return {
      filters: this.$store.state.filters,
      selectedFilter: this.$store.state.filters[0],
      searchFilter: "",
      eraser: false,
      selectedTemplate: null,
      collapsed: true,
      categoriesFound: false,
      succes: false
    };
  },
  methods: {
    onEraseFilter(filter) {
      this.searchFilter = "";
      filter = "";
      this.onFilterChange(filter);
    },

    selectedFilterChanged(filter) {
      this.selectedFilter = filter;
    },

    onFilterChange(filter) {
      if (this.searchFilter == "") {
        this.eraser = false;
      }
      if (this.searchFilter != "") {
        this.eraser = true;
      }
    },

    editTemplate(template) {
      this.$router.push({
        name: "template",
        params: { templateId: template.id }
      });
    },
    onTemplateSelected(template) {
      this.$set(template, "config", {});
      this.selectedTemplate = template;
    },
    onAddTemplate() {
      this.$modal.show(
        CreateTemplateModal,
        {
          selectedFilter: this.selectedFilter.id,
          onSave: () => {
            this.showNotice();
          }
        },
        { width: 310, height: "auto" }
      );
    },
    showNotice() {
      this.succes = true;
      setTimeout(
        function() {
          this.succes = false;
        }.bind(this),
        3500
      );
    }
  },
  computed: {
    filteredTemplates() {
      return this.$store.state.templates.filter((t) => {
        if (t.published) return false;
        if ((t.name || "").toLowerCase().indexOf(this.searchFilter.toLowerCase()) == -1) return false;
        if (this.selectedFilter.id === "all") return true;
        else return this.selectedFilter.categories.indexOf(t.contentType.name) > -1;
      });
    }
  },
  mounted() {
    demoHelper.handleDemoGuideStatus();
  },
  components: {
    TemplateList,
    TemplateSidePanel,
    FilterSearchbar,
    HeaderContent
  }
};
</script>

<style lang="less">
#home-view {
  // padding-left: var(--sidebar-width);
  background-color: var(--bg-grey);
  overflow: auto;

  .menu-content-wrapper {
    padding: 12px 0px 12px 24px;
    align-self: end;
  }
}

#home {
  padding-left: var(--sidebar-width);
  .template-picker {
    padding: 24px 12px 0;
    overflow: auto;

    .template-filter-input {
      font-size: 12px;
      border-radius: 20px;
      margin-right: 40px;
      position: relative;
      svg {
        position: absolute;
        right: 10px;
        top: 12px;
        width: 15px;
      }
      .search-icon {
        color: var(--charcoal-75);
        position: absolute;
        left: 0;
        top: 0;
        width: 40px;
        text-align: center;
      }
      input {
        font-size: 14px;
        transition: 0.3s;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
        border-radius: 20px;
        padding-left: 40px;
        width: 100%;
        color: var(--charcoal-75);
        border: none;
        &::placeholder {
          color: var(--charcoal-50);
        }
        &:focus,
        :active {
          outline: none;
          border: none;
          box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
          color: var(--charcoal);
        }
      }
    }
  }

  .top {
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    gap: 18px;
    // width: calc(100% - 40px);
    margin: 0 auto;

    // width: 90%;
  }

  .custom-filter .filter:last-of-type {
    border-bottom: 1px solid rgba(0, 0, 0, 0.11);
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
}
</style>
